import React, { CSSProperties, ReactNode } from 'react';
import styles from './AuthorizationLayout.module.scss';
import Logo from '../../Common/Logo/Logo';

interface Props extends JSX.ElementChildrenAttribute {
  subtitle?: string | JSX.Element | null;
  title?: string | null;
  description?: string | null;
  background: ReactNode;
  backgroundStyle?: CSSProperties;
}

const date = new Date();
function AuthorizationLayout(props: Props) {
  const { subtitle, title, description, background, backgroundStyle, children } = props;

  return (
    <div className={styles.layout}>
      <div className={`${styles.column} ${styles.left}`}>
        <div className={styles.intro} style={{ backgroundImage: `url(${background})`, ...backgroundStyle }}>
          <div className={styles.logoWrapper}>
            <Logo className={styles.logo} />
          </div>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
          {title && <h3 className={styles.title}>{title}</h3>}
          {description && <span className={styles.description}>{description}</span>}
          <span className={styles.copyright}>© {date.getFullYear()}, webfolio.com</span>
        </div>
      </div>
      <div className={styles.column}>{children}</div>
    </div>
  );
}

export default AuthorizationLayout;
